import { Error500Content } from './content'

export const Error500 = () => {
  return (
    <div className='flex h-screen flex-col gap-2 px-8 lg:px-24'>
      <Error500Content />
    </div>
  )
}
